'use client';

import { Icons } from '@/components/Shares/Icons';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { PROFILE_STATUS, useVerifyProfile } from '@/providers/VerifyProfileProvider';
import { Box, Flex, Grid, Image, Modal } from '@mantine/core';
import { ProfileIntroMobile } from './ProfileIntroMobile';
import { ProfileLeftSection } from './ProfileLeftSection';
import { ProfileMainControl } from './ProfileMainControl';
import { ProfileRightSection } from './ProfileRightSection';
import { ProfileStepper } from './ProfileStepper';
import classes from './VerifyProfile.module.css';
export const VerifyProfileModal: React.FC = () => {
  const {
    status,
    successes
  } = useVerifyProfile();
  const characterLocked = '/assets/kyc/character_2.png';
  const characterUnlocked = '/assets/kyc/character_armor.png';
  const {
    openModal,
    setOpenModal
  } = useModalAction();
  return <Modal opened={openModal === MODAL.VERIFY_PROFILE} onClose={() => setOpenModal(null)} closeButtonProps={{
    size: 37,
    bg: 'transparent',
    icon: <Icons className="icon-pr-line-close" fontSize={37} />
  }} overlayProps={{
    bg: 'rgba(23, 26, 30, 0.96)'
  }} size="100%" classNames={classes}>
      <ProfileStepper />

      <Flex direction={{
      base: 'column',
      sm: 'row'
    }} w="100%" justify="center" h="100%" pos="relative">
        <Grid w={{
        base: '100%',
        lg: '90%'
      }} mt={{
        sm: -60,
        lg: '-2rem'
      }}>
          <Grid.Col visibleFrom="sm" span={{
          sm: 4.6,
          lg: 3.25
        }}>
            <ProfileLeftSection />
          </Grid.Col>

          <Grid.Col span={5.5} visibleFrom="lg">
            <Box h="100%" pos="relative">
              <Image src={successes.has(PROFILE_STATUS.VERIFICATION) ? characterUnlocked : characterLocked} maw={689} mx="auto" />

              <ProfileMainControl />
            </Box>
          </Grid.Col>

          <Grid.Col span={{
          base: 12,
          sm: 7.4,
          lg: 3.25
        }} pos="relative" bg={{
          sm: 'var(--bg-100)',
          lg: 'transparent'
        }}>
            <Image visibleFrom="sm" hiddenFrom="lg" src="/assets/kyc/bg-tablet.png" pos="absolute" inset={0} style={{
            zIndex: 0,
            objectFit: 'contain'
          }} />
            <ProfileRightSection />
          </Grid.Col>
        </Grid>

        {status === PROFILE_STATUS.REGISTRATION && <ProfileIntroMobile />}
      </Flex>
    </Modal>;
};